import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async login ({ state, commit, dispatch }) {
    try {
      const result = await directus.login({
        email: state.email,
        password: state.password
      })

      commit('user/setAttr', {
        name: 'token',
        value: result.data.token,
      }, { root: true })

      dispatch('save')
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }

    return true
  }
}
